<script lang="ts" setup>
const isSaving = ref(false)
const hasSaved = ref(false)
const hasError = ref(false)

const props = defineProps<{
  modelValue: Record<string, any>
  apiRoute: string
  title?: string
  disabled?: boolean
}>()

async function saveData() {
  isSaving.value = true
  try {
    const response = await $fetch(props.apiRoute, {
      method: 'POST',
      body: props.modelValue,
    })
    console.log(response)
    hasSaved.value = true
  }
  catch (error) {
    hasError.value = true
    console.error(error)
  }
  isSaving.value = false
}
</script>

<template>
  <form
    class="gap-5 flex flex-col relative"
    @submit.prevent="saveData"
  >
    <h2
      v-if="title"
      class="px-6 py-6 text-2xl md:text-4xl lg:text-5xl font-display font-bold text-right bg-primary-dark"
    >
      {{ title }}
    </h2>
    <div class="flex flex-col gap-5 p-6">
      <slot />
      <ButtonBasic
        class="self-end "
        text="Submit"
        type="submit"
        :disabled="isSaving || hasSaved || disabled"
      />
    </div>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="hasError"
        class="bg-primary text-white px-3 py-1 lg:px-6 lg:py-4 flex items-center"
      >
        <Icon
          name="ic:sharp-error-outline"
          class="mr-3"
        />
        <p>
          There has been an error saving the data. Please try again or get in touch via
          <NuxtLink
            to="/contact"
            class="underline"
          > the contact page</NuxtLink>.
        </p>
      </div>
      <div
        v-else-if="hasSaved"
        class="absolute inset-0 bg-primary-dark/90 text-zinc-100 flex items-center justify-center"
      >
        <div class="flex flex-col items-center">
          <Icon
            name="ic:baseline-done"
            class="mr-3 text-4xl mt-2"
          />
          <p>
            Form sent! Thank you for your submission.
          </p>
        </div>
      </div>
      <div
        v-else-if="isSaving"
        class="absolute inset-0 bg-zinc-950/70 text-zinc-100 flex items-center justify-center"
      >
        <div class="flex flex-col items-center">
          <Icon
            name="ic:baseline-autorenew"
            class="animate-spin text-4xl text-primary"
          />
          <div class="text-center pt-2 font-title font-bold md:text-lg lg:text-xl">
            Sending...
          </div>
        </div>
      </div>
    </transition>
  </form>
</template>
